// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerTwoColumns_container__Ac5Pn","main":"ContainerTwoColumns_main__0Ss0Q","aside":"ContainerTwoColumns_aside__CEND0"};